/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcSweepsClearingV1SweepParticipantEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_SWEEPS_CLEARING_V1_SWEEP_PARTICIPANT_EVENT_ENTITY_NAME = 'ixc.sweeps.clearing.v1.SweepParticipantEvent';
export const ixcSweepsClearingV1SweepParticipantEventEntity = new schema.Entity<IxcSweepsClearingV1SweepParticipantEvent>(IXC_SWEEPS_CLEARING_V1_SWEEP_PARTICIPANT_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxcSweepsClearingV1SweepParticipantEvent) => `${entity.metadata?.eventId}` });

